import React, {useState, useRef} from 'react';
import '../../../css/ownmanage.scss';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css'
import APICall from '../../actions/apicall';
import Cookies from "js-cookie";
import cancelIcon from '../../../images/cancelIcon.png';
import Submit from '../reusable/Submit';
import Mappings from '../../actions/mappings';
import thumbsImage from '../../../images/thumbsImage.png';
import { trimCharacters } from '../../Helper';
import SVGImage from '../reusable/SelectIcon';
import { selectCategoryName } from '../../actions/findcategory';

function OwnManageBusinessBottomSheet (props) {
    const [showOwnBusinessContent, setShowOwnBusinessContent] = useState(true);
    const [selectInterestOptions, setSelectInterestOptions] = useState([]);
    const [selectSelfOptions, setSelectSelfOptions] = useState([]);
    const [errorMessage, setErrorMessage] = useState(false);
    const [showSelectText, setShowSelectText] = useState(false);
    const [claimErrorText, setClaimErrorText] = useState('');
    
    const errorText = useState('Please select at least one item.');
    const interestOptions = ['get_investment', 'get_loan', 'insure_business', 'sell_business', 'buy_business', 'other'];
    const selfOptions = ['owner', 'manager'];

    const handleClaimBusiness = (actions) => { 
        (errorMessage) && setErrorMessage(false);
        (showSelectText) && setShowSelectText(false);
        if (actions != 'close') {
            if (selectInterestOptions.length == 0 || selectSelfOptions.length == 0) {
                setShowSelectText(true);
                return
            }
        }
        selectInterestOptions.map((item, index)=>{
            window.dataLayer.push({
                'event': 'select_content',
                'contentType': 'claim_interest',
                'contentId': item,
                'businessId': props.business.id
            })
        });
        window.dataLayer.push({
            'event': 'select_content',
            'contentType': 'claim_user_description',
            'contentId': selectSelfOptions,
            'businessId': props.business.id
        });
        let submitted = true;
        (actions == 'close') && (submitted = false);
        if(submitted){
        window.dataLayer.push({
            'event': 'claim_business_submit', 
            'businessId': props.business.id
        });
        }
        let data = {
            "business_id": props.business.id,
            "relationship": (selectSelfOptions.length != 0 ? selectSelfOptions : null),
            "reasons": (selectInterestOptions.length != 0 ? selectInterestOptions.join(", ") : null),
            "submitted": submitted
        }
        let accessToken = Cookies.get('access_token') ?? null;
        APICall.ClaimBusiness(data, accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success' && response.data.data) {
                setShowOwnBusinessContent(false);
            }
            else {
                setClaimErrorText(response.data.message);
                setErrorMessage(true);
            }
        })
    }

    const handleCloseButtonClick = () => {  
        window.dataLayer.push({
        'event': 'claim_business_exit', 
        'businessId': props.business.id
    }); 
        handleClaimBusiness('close');
        (errorMessage) && (setErrorMessage(false));
        props.closeOwnBusiness();
    };

    const handleReturn = () => {
        props.closeOwnBusiness();
    }


    return(
        <BottomSheet open={true} onDismiss={handleCloseButtonClick}
            header={
                <div className="transparent-header">
                    <img className='cancel-icon' height='25px' src={cancelIcon} onClick={handleCloseButtonClick} />
                </div>
            }
        >
            {
                (showOwnBusinessContent) ? (
                <div className='own-business-container'> 
                    <div className='logo-name'>
                        <div className='business-category-container'>
                                <SVGImage category={props.business.fields.category} />
                                <p>{selectCategoryName(props.business.fields.category)}</p>
                            </div>
                        <div className='name-address'>
                            <p className='business-name-text' title={props.business.fields.business_name}>{trimCharacters(props.business.fields.business_name)}</p>
                            {
                                (props.business.fields.full_address) ? (
                                    <p className='business-address'>{props.business.fields.full_address}</p>
                                ) : (
                                    (props.business.fields.category != 'Airbnb') ? (
                                    <p className='business-address'>{props.business.fields.location_address}, 
                                        {props.business.fields.location_address_city}, {props.business.fields.location_address_state},
                                        {props.business.fields.zip_code}
                                    </p>) : (
                                        <p className='business-address'>{props.business.fields.location_address}</p>
                                    )
                                )
                            }
                        </div>
                    </div>   
                    <div className='own-business-content'>
                        <p className='name-text'>Describe Yourself</p>
                        <div className='options-container'>
                            {
                                selfOptions.map((item, i) => (
                                    <button key={item} 
                                        className={selectSelfOptions.includes(item) ? 'option-button highlight-border' : 'option-button'} 
                                        onClick={() => setSelectSelfOptions(item)}>
                                        <span 
                                            className={selectSelfOptions.includes(item) ? 'button-text highlight-color' : 'button-text'}>
                                            {Mappings[item]}
                                        </span>
                                    </button>
                                ))
                            }
                        </div>
                        <p className='name-text'>What are you interested in?</p>
                        <p className='select-text'>Select all that apply:</p>
                        <div className='options-container'>
                            {
                                interestOptions.map((item, i) => (
                                    <button key={item} 
                                        className={selectInterestOptions.includes(item) ? 'option-button highlight-border' : 'option-button'} 
                                        onClick={() => setSelectInterestOptions(selectInterestOptions.includes(item) ?
                                            selectInterestOptions.filter(current => current != item) : [...selectInterestOptions, item]
                                    )}>
                                        <span 
                                            className={selectInterestOptions.includes(item) ? 'button-text highlight-color' : 'button-text'}>
                                            {Mappings[item]}
                                        </span>
                                    </button>
                                ))
                            }
                        </div>
                        {
                            (errorMessage) && (
                            <p className='error-text'>{claimErrorText}</p>)
                        }
                        {
                            (showSelectText && (selectInterestOptions.length == 0 || selectSelfOptions.length == 0)) && (
                            <p className='error-text'>{errorText}</p>)
                        }
                        <button className='next-button enable' onClick={() => handleClaimBusiness('claim')}>
                            <span>Next</span>
                        </button>
                    </div>
                </div>) : (
                <div className='final-message'>
                    <img className='thumb-image' src={thumbsImage} />
                    <p className='message-text'>
                        <span className='bold-text'>THANK YOU </span>
                        for providing us your interests. RS11 is building a national network of providers and we will contact you about your needs.</p>
                    <Submit actionText={'Return to map'} callFunction={handleReturn} />
                </div>
                )
            }
        </BottomSheet>
    )
}

export default OwnManageBusinessBottomSheet;